//redux/actions/meals.js
import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllMeals = (page, limit, categoryId, titleAr, titleEn, sortOrder) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_meals_request' });

        // تحضير params object
        const params = {
            page,
            limit,
        };
        
        // إضافة الفلاتر إذا كانت موجودة
        if (categoryId) params.categoryId = categoryId;
        if (titleAr) params.titleAr = titleAr;
        if (titleEn) params.titleEn = titleEn;
        if (sortOrder) params.sortOrder = sortOrder; // إضافة معامل الترتيب

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/blogs`, {
            params: params,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_meals_success',
            payload: {
                meals: data.blogs,
                pagination: data.pagination,
                totalmeals: data.totalBlogs
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_meals_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getFillterMeals = (page , limit,categoryId ,titleAr,titleEn,price) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_meals_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/blogs/filter`, {
            params: {
                page,
                limit,
                categoryId,
                titleAr,
                titleEn,
                price
            },
            withCredentials: true,
        } )
    ;

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_meals_success',
            payload: {
                meals: data.blogs,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_meals_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getMeal = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_meal_request' });

        const { data } = await axios.get(`${BaseUrl}/blogs/${id}`);
      
        dispatch({ type: 'get_meal_success' ,payload:data.blog});

    } catch (error) {
        dispatch({
            type: "get_meal_error",
            payload: error.response.data.message,
          });
    }
}
export const createMeal = (newForm) => async (dispatch) => {
    try {
        dispatch({ type: 'create_meal_request' });
        const config = { headers: { "Content-Type": "multipart/form-data" } };
        const { data } = await axios.post(`${BaseUrl}/blogs/create`,
           newForm,
           config);

        dispatch({ type: 'create_meal_success', payload: data.blog });
    } catch (error) {
        dispatch({
            type: "create_meal_error",
            payload: error.response.data.message,
          });
    }
};
// redux/actions/meals.js - إضافة action جديد فقط
export const getFilteredMealsWithSort = (page, limit, filters) => async (dispatch) => {
    try {
        dispatch({ type: 'get_FillterWithSort_meals_request' });

        // بناء parameters مع جميع الفلاتر
        const params = {
            page,
            limit,
            categoryId: filters.categoryId || undefined,
            titleAr: filters.search || undefined,
            titleEn: filters.search || undefined,
            priceMin: filters.priceMin || undefined,
            priceMax: filters.priceMax || undefined,
            sortBy: filters.sortBy || 'default'
        };

        const { data } = await axios.get(`${BaseUrl}/blogs/filter-enhanced`, {
            params,
            withCredentials: true,
        });

        dispatch({
            type: 'get_FillterWithSort_meals_success',
            payload: {
                meals: data.blogs,
                pagination: data.pagination,
            },
        });

    } catch (error) {
        dispatch({
            type: "get_FillterWithSort_meals_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const deleteMeal = (id) => async (dispatch) => {
    try {
    
        dispatch({ type: 'delete_meal_request' });

     const {data} =  await axios.delete(`${BaseUrl}/blogs/${id}`);

        dispatch({ type: 'delete_meal_success' ,
    payload: data.message
    });
    } catch (error) {
        dispatch({
            type: "delete_meal_error",
            payload: error.response.data.message,
          });
    }
};
export const ClearMeal = () => async (dispatch) => {    
    dispatch({ type: 'clear_blog' });
}